module.exports = __webpack_public_path__ + "img/1x2gaming.d3f431f4.svg";